import CloseIcon from '@mui/icons-material/Close';
import DeleteIcon from '@mui/icons-material/Delete';
import { Box, IconButton } from '@mui/material';
import { useAppDispatch, useAppSelector } from '../../app/hooks';
import { flexCenter } from '../commonUI/cssClasses';
import StyledPopup from './StyledPopup';
import {
  deleteMapMarker,
  selectCurrMapMarkerPopup,
  setCurrMapMarkerPopup,
} from './mapSlice';

const MarkerPopup: React.FC = () => {
  const dispatch = useAppDispatch();
  const currMapMarkerPopup = useAppSelector(selectCurrMapMarkerPopup);

  if (!currMapMarkerPopup) return null;

  const handleClickDelete = () => {
    dispatch(deleteMapMarker(currMapMarkerPopup.id));
    dispatch(setCurrMapMarkerPopup(null));
  };

  const handleClickClose = () => {
    dispatch(setCurrMapMarkerPopup(null));
  };

  return (
    <StyledPopup
      longitude={currMapMarkerPopup.lng}
      latitude={currMapMarkerPopup.lat}
      offset={50}
      closeButton={false}
      className='marker-popup'
      closeOnClick={false}
      padding='0rem'
    >
      <Box sx={{ ...flexCenter, flexDirection: 'row' }}>
        <IconButton aria-label='delete' onClick={handleClickDelete}>
          <DeleteIcon sx={{ color: (theme) => theme.colors.common.white }} />
        </IconButton>
        <IconButton aria-label='delete' onClick={handleClickClose}>
          <CloseIcon sx={{ color: (theme) => theme.colors.common.white }} />
        </IconButton>
      </Box>
    </StyledPopup>
  );
};

export default MarkerPopup;
